import React from 'react';
import { ReactComponent as ArrowGoBack } from 'images/new-icons/arrow-go-back.svg';
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';
import styles from './ArrowSvgLang.module.scss';

type Props = {
    onClick?: () => void;
    className?: string;
    style?: React.CSSProperties;
};

const ArrowSvgLang: React.FC<Props> = ({ onClick, className, style }) => {
  const { i18n } = useTranslation();

return (
    <> 
    <ArrowGoBack
        onClick={onClick}
        className={clsx(
            styles.arrow,
            { [styles.arrowRtl]: i18n.dir() === 'rtl' },
            className
        )}
        style={style}
    /> </>
);
};

export default ArrowSvgLang;
